import { bool, node, object } from "prop-types";
import { BreakdownTableDepths, BreakdownColumns } from "@repo/utils";
import { observer } from "mobx-react";
import {
  PinnableCell,
  useEstimateEditorSettings, useEstimateTableSettings,
  usePresetFieldNames
} from "@tools";
import { LastPinnedCellActions } from "../components/LastPinnedCellActions";
import { useMemo } from "react";
import useCellStyle from "@tools/EstimateEditor/styles/CommonTableCellStyles.style";
import classnames from "classnames";
import Grid from "@material-ui/core/Grid";

export const TaskTitleCell = observer(({
  children,
  columnSettings,
  section,
  isLastPinnedCell,
  isLastPinnableCell,
}) => {
  
  const { allowEdition, isProposal, isLibrary } = useEstimateEditorSettings();
  const { showNumerationColumn, showActionsOnScroll } = useEstimateTableSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const cellClasses = useCellStyle();
  
  const { startingLevel } = section;
  const { pinLeftPx } = columnSettings;
  
  const showActions = useMemo(() => (
    showActionsOnScroll ? isLastPinnedCell : isLastPinnableCell
  ), [ isLastPinnedCell, isLastPinnableCell, showActionsOnScroll ]);
  
  return <>
    <PinnableCell
      resizeable
      isHeader
      colName={ BreakdownColumns.TITLE }
      
      allowOverflowDisplay={isLastPinnedCell}
      pinnedLeft={typeof pinLeftPx === "number"}
      
      containers={children}
      actions={ showActions && <LastPinnedCellActions section={section} /> }
      allowEdition={ allowEdition && !isLibrary }
      columnSettings={ columnSettings }
      innerClassName="items-end"
    >
      <Grid
        item container
        alignItems="center"
        className={classnames(cellClasses.sizeXSmall)}
      >
        <span className="preset-tableBreakdownHeader pt-module text-left">
          { getFieldName("pt-module", isLibrary ? startingLevel : BreakdownTableDepths.SECTION, showNumerationColumn) }
        </span>
      </Grid>
    </PinnableCell>
  </>
})

TaskTitleCell.propTypes = {
  section: object.isRequired,
  columnSettings: object.isRequired,
  children: node,
  isLastPinnedCell: bool,
  isLastPinnableCell: bool,
}